import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routes = [
  {
    // ======================
    // Full Layout
    // ======================
    path: "",
    component: () => import("./layout/full/MainContainer.vue"),
    beforeEnter: authorize,
    // ======================
    // Theme routes / pages
    // ======================
    children: [
      {
        path: "/",
        name: "Dashboard",
        index: 1,
        component: () => import("./views/StarterPage.vue"),
      },
      {
        path: "/admin-users",
        name: "Admin Accounts",
        index: 2,
        component: () => import("./views/components/main/adminUsers.vue"),
      },
      {
        path: "/site-settings",
        name: "Site Settings",
        index: 2,
        component: () => import("./views/components/main/siteSettings.vue"),
      },
      {
        path: "/users",
        name: "Users",
        index: 3,
        component: () => import("./views/components/main/users.vue"),
      },
      {
        path: "/logout",
        name: "Logout",
        index: 58,
        component: () => import("./views/components/main/logout.vue"),
      },
      {
        path: "/change-password",
        name: "Change Password",
        index: 13,
        meta: { access: "MASTER" },
        component: () => import("./views/components/main/changePassword.vue"),
      },
      {
        path: "/upload-industry",
        name: "Upload Industry",
        index: 14,
        meta: { access: "MASTER" },
        component: () => import("./views/components/main/uploadIndustry.vue"),
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    index: 11,
    beforeEnter: unAuthorize,
    component: () => import("./views/Login.vue"),
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    index: 12,
    beforeEnter: unAuthorize,
    component: () => import("./views/ForgotPassword.vue"),
  },
  {
    path: "/404-page-not-found",
    name: "NotFound",
    index: 177,
    component: () => import("./views/404.vue"),
  },
  {
    path: "/",
    name: "home",
    index: 179,
    component: () => import("./views/Home.vue"),
  },
  // Redirect to starterkit page, if no match found
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  fallback: true,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;


function authorize(to, from, next) {
  if (JSON.parse(localStorage.getItem("user")) != null) {

    if (
      JSON.parse(localStorage.getItem("user")).access_token != undefined
    ) {
      next();
      return;
    }
    // NO Restriction for admin
    router.push("/404-page-not-found");
    return;
  }
  localStorage.clear();
  router.push("/login");
}

function unAuthorize(to, from, next) {
  if (JSON.parse(localStorage.getItem("user")) == null) {
    next();
    return;
  }
  router.push("/dashboard");
}
